import { html, css, PropertyValues } from 'lit';
import { BaseWidget } from "../base-widget";
import { property } from 'lit/decorators.js';

// Quick link default widget implementation.  This has a static content
export class WorkspaceDefault extends BaseWidget {
    static get styles() {
        return css`
          .text-center { text-align: center; }
          .text-left { text-align: left; }
          .text-right { text-align: right; }
          .col-sm-12 { width: 100%; }
          .col-sm-1 { width: 8%; float: left; }
          .col-sm-11 { width: 92%;  float: left; }
          .default-widget-button { cursor: default !important; line-height: 4px;min-width: auto}
          .no-padding{ padding: 0px !important;}
          .button {border: none;color: #ffffff !important;background-color: #004693 !important;border-radius: 5px;outline: none;text-decoration: none;min-width: 7rem;padding: 0.6rem 1.3rem !important;display: inline-block;text-align: center;text-decoration: none;}
          .widget-content-class{padding: 3px;}
          .widgetbox {
                border: 1px solid #75787b;
                border-radius: 5px;
                background: #ffffff;
                margin-right: 15px;
                margin-bottom: 15px;
                margin-top: 10px;
                min-height: 40px;
            }
        `;
    }
    // Widget is loaded, so refresh window based on state
    firstUpdated(changedProperties: PropertyValues) {
        this.showOrHideForState();
    }


    // Overriding content part of the widget.render().  We just need a slot here!
    getContentLoaderSlot() {
        return html`
            <div class="widget-content-class">
                <div class="container-fluid">
                    <div class="row">
                        <div class="text-center col-sm-12 no-padding img-responsive"><img width="100%" src="/resources/images/module/landingpage/Welcome_Widget_Image.jpg"/></div>
                    </div>
                    <div class="row">
                        <div class="text-center col-sm-12 krypton-base-header "><h1 class="title-font">Welcome to SoCalGas Envoy<sup>&reg;</sup>!</h1></div>
                    </div>
                    <div class="row">
                        <div class="text-center col-sm-12">ENVOY has undergone a significant change.  Here at SoCalGas Envoy<sup>&reg;</sup>, we are always looking to</div>
                    </div>
                    <div class="row">
                        <div class="text-center col-sm-12">improve user experience and gas scheduling efficiency.</div>
                    </div>

                    <div class="row">
                        <div class="text-left col-sm-12 medium_title">&nbsp;</div>
                    </div>
                    <div class="row">
                        <div class="text-left col-sm-12 medium_title">Tips to customizing the Landing Page:</div>
                    </div>

                    <div class="row">
                        <div class="text-right col-sm-1 no-padding column_align_middle">1.</div>
                        <div class="no-padding col-sm-11 ">
                            <div class="text-left column_align_middle  p-l-1">
                                Click the <button class="button button_style default-widget-button">Add Widgets</button> button in the top right to add more Quicklinks, Workspace and Informational widgets.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="text-right col-sm-1 no-padding">2.</div>
                        <div class="no-padding col-sm-11 ">
                            <div class="text-left p-l-1">
                                You can remove widgets by clicking the <img src="/resources/images/icons/close.svg"/> in the top right of the widget header.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="text-right col-sm-1 no-padding">3.</div>
                            <div class="no-padding col-sm-11 ">
                                <div class="text-left  p-l-1">If you do not want to see a widget, but also do not want to remove it from your Landing Page, you can click the <img src="/resources/images/icons/minimize.svg"/> icon also in the top right of the widget header.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="text-right col-sm-1 no-padding">4.</div>
                        <div class="no-padding col-sm-11 ">
                            <div class="text-left  p-l-1">
                                Finally, you can rearrange the order of your widgets in their specified column by dragging and dropping the widget header.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="text-left col-sm-12">For assistance please contact our helpline number (213) 244-3900. For technical support please contact (800)427-0018.</div>
                    </div>
                </div>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'workspace-default': WorkspaceDefault;
    }
}

